import { networkNames } from '@shared/types/executor';
import { ACTIVE_NETWORKS, ChainId, NETWORK_LOGOS } from '@shared/utils/config/networks';
import { ChevronDown } from 'lucide-react';
import { useRouter } from 'next/router';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import getNetworkLogo from '@/lib/misc/getNetworkLogo';
import { ImageWithFallback } from '@/components/shared/NextImageFallback';
interface FilterNetworkDropdownProps {
  setNetwork: (_: number[]) => void;
  network: number[];
  defaultNetwork: number[];
  customHandler?: boolean;
}
const FilterNetworkDropdown = ({
  setNetwork,
  network,
  defaultNetwork,
  customHandler = false
}: FilterNetworkDropdownProps) => {
  const router = useRouter();
  const networks = [{
    networkName: 'All Networks',
    chainId: 'all-networks',
    networkLogo: '/static/genius.png'
  }, ...ACTIVE_NETWORKS.map(x => ({
    networkName: ChainId[x] || 'All Networks',
    chainId: x,
    networkLogo: NETWORK_LOGOS[x] || '/static/images/defaultnetwork.png'
  }))];
  const _handleOnSelectNetwork = (value: {
    networkName: string;
    chainId: number;
    networkLogo: any;
  } | {
    networkName: string;
    chainId: string;
    networkLogo: string;
  }) => {
    setNetwork(value.networkName === 'All Networks' ? defaultNetwork : [Number(value.chainId)]);
    if (!customHandler) {
      if (value.networkName !== 'All Networks') {
        router.push({
          pathname: '/home',
          query: {
            ...router.query,
            networkId: value.chainId
          }
        }, undefined, {
          shallow: true
        });
      } else {
        const {
          networkId,
          ...routerQuery
        } = router.query;
        router.push({
          pathname: '/home',
          query: {
            ...routerQuery
          }
        }, undefined, {
          shallow: true
        });
      }
    }
  };
  return <DropdownMenu data-sentry-element="DropdownMenu" data-sentry-component="FilterNetworkDropdown" data-sentry-source-file="FilterNetworkDropDown.tsx">
      <DropdownMenuTrigger asChild data-sentry-element="DropdownMenuTrigger" data-sentry-source-file="FilterNetworkDropDown.tsx">
        <Button variant={network?.length > 1 ? 'blue' : 'pink'} className={`flex gap-2 items-center rounded-full w-fit h-[32px] px-[7px] py-[3px]`} data-sentry-element="Button" data-sentry-source-file="FilterNetworkDropDown.tsx">
          <ImageWithFallback src={network?.length > 1 ? '/static/genius.png' : getNetworkLogo(network?.[0])} alt='selected-network-logo' width={100} height={100} className='w-[14px] h-[14px]' data-sentry-element="ImageWithFallback" data-sentry-source-file="FilterNetworkDropDown.tsx" />
          <p>
            {network?.length > 1 ? 'All Networks' : networkNames[network?.[0]] === 'Binance Smart Chain' ? 'Binance' : networkNames[network?.[0]]}
          </p>
          <ChevronDown className='w-[12px] h-[12px]' data-sentry-element="ChevronDown" data-sentry-source-file="FilterNetworkDropDown.tsx" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className='border-genius-blue bg-genius-indigo w-[154px] z-[3000]' data-sentry-element="DropdownMenuContent" data-sentry-source-file="FilterNetworkDropDown.tsx">
        {networks.map(networkItem => <DropdownMenuItem key={networkItem.chainId} onSelect={() => _handleOnSelectNetwork(networkItem)}>
            <div className='flex gap-2 items-center hover:bg-genius-blue'>
              <ImageWithFallback src={networkItem.networkLogo} width={20} height={20} alt={`${networkItem.networkName}-logo`} className='h-[20px] w-[20px]' />
              <span className='capitalize'>{networkItem.networkName.replace('-mainnet', '')}</span>
            </div>
          </DropdownMenuItem>)}
      </DropdownMenuContent>
    </DropdownMenu>;
};
export default FilterNetworkDropdown;